<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-modal-print
                                ref="print"
                                @close-method="(file_name = null), $refs.print.close()"
                                :file-name="file_name"
                                :no-button="true"
                            ></bc-modal-print>
                            <bc-btn-add
                                @invoke-method="dev_mode ? showPrinter() : printLabel()"
                                icon="summarize"
                                :tooltip="$t('lang.print_qr_codes')"
                            ></bc-btn-add>
                            <bc-btn-add @invoke-method="invokeMethod($event)" action="openAdd" perm="parts.create"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetParts()"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams" @open="getArrayData()">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.company_id"
                                            :label="$t('lang.company_id')"
                                            :items="customer_options"
                                            item-value="company_id"
                                            item-text="company"
                                            prepend-icon="business"
                                            single-line
                                            :hide-details="true"
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobileList"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="parts" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="showPart(props.item)">
                                <td><img :src="props.item.photo" style="max-width: 50px; max-height: 50px" /></td>
                                <td>{{ props.item.company }}</td>
                                <td>{{ props.item.name }}</td>
                                <td>{{ props.item.customer_part_number }}</td>
                                <td>{{ props.item.in_production == "1" ? $t("lang.mass") : $t("lang.prototype") }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="parts"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="part_dialog" max-width="700">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{
                            currObjField("part_id") ? (hasScope("update") ? $t("lang.edit_part") : $t("lang.part_details")) : $t("lang.add_part")
                        }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close @invoke-method="invokeMethod($event)" action="closePartDialog" :dialog-status="part_dialog"></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="part">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                            v-focus="part_dialog"
                                            v-model="part.name"
                                            :label="`${$t('lang.part_name')} *`"
                                            :counter="showCounter(part.name, 'part.name')"
                                            :rules="ifValid('part.name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                            v-model="part.customer_part_number"
                                            :label="`${$t('lang.customer_part_number')} *`"
                                            :counter="showCounter(part.customer_part_number, 'part.customer_part_number')"
                                            :rules="ifValid('part.customer_part_number')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                            v-model="part.dta_part_code"
                                            :label="`${$t('lang.dta_part_code')} *`"
                                            :counter="showCounter(part.dta_part_code, 'part.dta_part_code')"
                                            :rules="ifValid('part.dta_part_code')"
                                            type="number"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <bc-autocomplete
                                            v-model="part.company_id"
                                            :label="`${$t('lang.company_id')} *`"
                                            :items="customer_options"
                                            item-value="company_id"
                                            item-text="company"
                                            :rules="ifValid('part.company_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                            v-model="part.material"
                                            :label="`${$t('lang.material')} *`"
                                            :counter="showCounter(part.material, 'part.material')"
                                            :rules="ifValid('part.material')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                            v-model="part.project_name"
                                            :label="`${$t('lang.project_name')}`"
                                            :counter="showCounter(part.project_name, 'part.project_name')"
                                            :rules="ifValid('part.project_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                            v-model="part.batch_size"
                                            :label="`${$t('lang.batch_size')} *`"
                                            :counter="showCounter(part.batch_size, 'part.batch_size')"
                                            :rules="ifValid('part.batch_size')"
                                            type="number"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <bc-autocomplete
                                            v-model="part.line_id"
                                            :label="`${$t('lang.line_id')} *`"
                                            :items="production_lines"
                                            item-value="line_id"
                                            item-text="production_line"
                                            :rules="ifValid('part.line_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currObjField('part_id') && hasScope('delete')" color="error" @mouseup.left="$refs.delete_part.openDialog()">{{
                            $t("lang.delete")
                        }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closePartDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn
                            v-if="currObjField('part_id') ? hasScope('update') : hasScope('create')"
                            color="success"
                            @mouseup.left="modifyPart(currObjField('part_id') ? 'patch' : 'post', currObjField('part_id'))"
                            >{{ $t("lang.save") }}</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_part"
                :heading="$t('lang.delete_part')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyPart('delete', currObjField('part_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                { text: "", sortable: false, align: "center", width: "60" },
                { text: this.$t("lang.company"), sortable: false },
                { text: this.$t("lang.name"), sortable: false },
                { text: this.$t("lang.customer_part_number"), sortable: false },
                { text: this.$t("lang.production"), sortable: false },
            ],
            customers: null,
            file_name: null,
            part: {
                project_name: "",
                dta_part_code: "",
                customer_part_number: "",
                name: "",
                company_id: "",
                material: "",
                batch_size: "",
                line_id: "",
            },
            current_obj: null,
            filter: {
                search: "",
                company_id: "",
                page_size: 0,
                page_num: 0,
            },
            part_dialog: false,
            dbGetParts: _.debounce(this.getParts, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchPart", {
                url: "parts",
                method: "get",
                stateProperty: "parts",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.parts) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchPart", {
                url: "parts",
                method: "get",
                stateProperty: "parts",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.parts) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_part: (state) => state.validation.rules_part,
            default_filter: (state) => state.parts.parts_filter,
            page: (state) => state.parts.page,
            parts: (state) => state.parts.parts,
            production_lines: (state) => state.production.production_lines,
            customer_options: (state) => state.customers.customer_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
        hasScope() {
            return (scope) => {
                return this.currObjField("scope").includes(`${scope}`) || !this.currObjField("part_id");
            };
        },
        mobileList() {
            let modifylist = [
                { title: this.$t("lang.print_qr_codes"), action: this.dev_mode ? "showPrinter" : "printLabel" },
                { title: this.$t("lang.add_new"), action: "openAdd", perms: ["parts.create"] },
                { title: this.$t("lang.refresh"), action: "dbGetParts" },
            ];

            return modifylist;
        },
    },
    methods: {
        ...mapActions(["fetchCustomers"]),
        openAdd() {
            this.getArrayData();
            this.part_dialog = true;
            if (this.production_lines == null) this.getProductionLines();
        },
        getProductionLines() {
            this.$store
                .dispatch("fetchProduction", {
                    url: "production_lines",
                    method: "get",
                    stateProperty: "production_lines",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                });
        },
        getArrayData() {
            if (this.customers == null) this.getCustomers();
        },
        closePartDialog() {
            this.part_dialog = false;
            if (this.$refs.delete_part) this.$refs.delete_part.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getParts() {
            this.startLoader();
            this.$store
                .dispatch("fetchPart", {
                    url: "parts",
                    method: "get",
                    stateProperty: "parts",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.part_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        getCustomers() {
            this.fetchCustomers({ body: { options: 1 } });
        },
        modifyPart(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("part")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchPart", {
                                pk: "part_id",
                                id: id,
                                url: `parts/${id ? id : ""}`,
                                method: method,
                                stateProperty: "parts",
                                mutate: true,
                                body: this.part,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closePartDialog();
                                    if (method == "post") this.$router.push({ name: "part_profile", params: { id: data.parts.part_id } });
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showPart(item = null) {
            if (item) this.$router.push({ name: "part_profile", params: { id: item.part_id } });
        },
        showPrinter() {
            this.$refs.print.openDialog();

            this.$store
                .dispatch("fetchPart", {
                    url: `parts/print_qr`,
                    method: "get",
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.customer_qr_codes) {
                        this.file_name = data.customer_qr_codes.file_name;
                    } else {
                        this.file_name = "";
                        this.$refs.print.close();
                        this.createAlert();
                    }
                });
        },
        printLabel() {
            this.$store.commit("toggleGlobalSnackbar", true);
            this.$store
                .dispatch("fetchPart", {
                    url: `parts/print_qr`,
                    method: "get",
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.customer_qr_codes) {
                        this.$refs.print.printReport(data.customer_qr_codes.file_name);
                    } else {
                        this.createAlert();
                    }
                    this.$store.commit("toggleGlobalSnackbar", false);
                });
        },
    },
};
</script>
